export default __webpack_public_path__ + "static/media/R1.c851feba.PNG";